import React, { VFC } from 'react';
import styled, { css } from 'styled-components';
import SvgIcon from '../atoms/SvgIcon';
import { IconVariants } from '../atoms/icons/types';
import { theme } from '../../utils/theme';
import Typography from '../atoms/Typography';
import Spacing from '../atoms/Spacing';

interface IWrapper extends React.HTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
}
interface ICircle extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
}
interface Props
  extends React.HTMLAttributes<HTMLDivElement & HTMLButtonElement> {
  disabled?: boolean;
  icon: IconVariants;
  iconColor?: string;
  backgroundColor?: string;
  labelColor?: string;
  labelLeft?: string;
  labelRight?: string;
  onClick?: () => void;
}

const Wrapper = styled.div<IWrapper>`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.1;
      :hover {
        opacity: 0.1;
      }
    `}
  cursor:pointer;
`;

const StyledCircle = styled.div<ICircle>`
  display: flex;
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  ${Wrapper}:hover & {
    opacity: 1;
  }
`;

const IconButton: VFC<Props> = ({
  icon,
  iconColor = theme.colors.grey[0],
  disabled = false,
  backgroundColor = theme.colors.primary[80],
  labelLeft,
  labelRight,
  onClick,
}) => (
  <Wrapper onClick={onClick} disabled={disabled}>
    {labelLeft && (
      <>
        <Typography variant="body1-semi-bold" translateKey={labelLeft} />
        <Spacing horizontal />
      </>
    )}
    <StyledCircle backgroundColor={backgroundColor}>
      <SvgIcon icon={icon} iconSize="large" color={iconColor} />
    </StyledCircle>
    {labelRight && (
      <>
        <Spacing horizontal />
        <Typography variant="body1-semi-bold" translateKey={labelRight} />
      </>
    )}
  </Wrapper>
);

export default IconButton;
